import {
  FieldsetHTMLAttributes,
  HTMLAttributes,
  PropsWithChildren,
} from 'react';
import { IconType } from 'react-icons';
import { VariantProps } from 'tailwind-variants';
import { Icon } from '../../Icon';
import { Divider, IsVisible } from '../../utils';
import { fieldsetStyles } from './styles';

interface IFieldsetProps
  extends FieldsetHTMLAttributes<HTMLFieldSetElement>,
    VariantProps<typeof fieldsetStyles.fieldset> {
  contentClassName?: string;
  error?: string;
  icon?: IconType;
  legend?: string;
  legendProps?: {
    className?: string;
    rest?: HTMLAttributes<HTMLLegendElement>;
    variants?: VariantProps<typeof fieldsetStyles.legend>;
  };
}

export function Fieldset({
  children,
  className,
  contentClassName,
  error,
  icon,
  legend,
  legendProps,
  ...rest
}: PropsWithChildren<IFieldsetProps>): JSX.Element {
  return (
    <div className="flex flex-col w-full">
      <fieldset
        className={fieldsetStyles.fieldset({
          className,
          errored: !!error,
        })}
        {...rest}
      >
        <IsVisible when={!!legend}>
          <legend
            className={fieldsetStyles.legend({
              className: legendProps?.className,
              errored: !!error,
            })}
            {...legendProps?.rest}
          >
            {legend}
          </legend>
        </IsVisible>
        <div
          className={fieldsetStyles.content({ className: contentClassName })}
        >
          <IsVisible when={!!icon}>
            <Icon
              className="mb-[2px] min-w-16 mx-2"
              iconName={icon as IconType}
            />
            <Divider
              className="bg-secondaryFixxer-one w-4"
              orientation="vertical"
            />
          </IsVisible>
          {children}
        </div>
      </fieldset>
      <IsVisible when={!!error}>
        <div className="flex mt-1">
          <span className="text-primary-two">{error}</span>
        </div>
      </IsVisible>
    </div>
  );
}
